import { isValidEmail, validateContactInquiry, } from "@diality/contracts";
const FIELD_LABELS = {
    audience: "Role",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone number",
    message: "Message",
};
/** Translate API keys into guidance for the controls this form actually shows. */
export function requiredFieldsMessage(fields) {
    const labels = [...new Set(fields)]
        .filter((field) => Object.hasOwn(FIELD_LABELS, field))
        .map((field) => FIELD_LABELS[field]);
    const messages = [];
    if (labels.length)
        messages.push(`Please complete the following fields: ${labels.join(", ")}.`);
    if (fields.includes("consent")) {
        messages.push("Please check the box to agree to be contacted and accept the privacy policy.");
    }
    return messages.join(" ") || "Please review your details and try again.";
}
/** Require an area code and seven-digit number; allow country codes and formatting. */
function isValidPhone(value) {
    if (!/^\+?[\d\s().-]+$/.test(value))
        return false;
    const digits = value.replace(/\D/g, "");
    if (digits.length < 10 || digits.length > 15)
        return false;
    // Parentheses must be paired, with no nested or empty groups.
    let open = false;
    let groupDigits = 0;
    for (const char of value) {
        if (char === "(") {
            if (open)
                return false;
            open = true;
            groupDigits = 0;
        }
        else if (char === ")") {
            if (!open || !groupDigits)
                return false;
            open = false;
        }
        else if (open && /\d/.test(char)) {
            groupDigits++;
        }
    }
    return !open;
}
export function validateContactForm(inquiry, consent) {
    const missing = [...validateContactInquiry(inquiry)];
    if (!consent)
        missing.push("consent");
    const invalid = [];
    const messages = missing.length ? [requiredFieldsMessage(missing)] : [];
    if (inquiry.email.trim() && !isValidEmail(inquiry.email.trim())) {
        invalid.push("email");
        messages.push("Please enter a valid email address, such as name@example.com.");
    }
    if (inquiry.phone?.trim() && !isValidPhone(inquiry.phone.trim())) {
        invalid.push("phone");
        messages.push("Please enter a valid phone number including the area code, such as (555) 123-4567 or +44 20 7946 0958.");
    }
    return { missing, invalid, message: messages.join(" ") };
}
//# sourceMappingURL=contact-form-validation.js.map